import axiosInstance from "../../utils/axiosConfig";
import { compactParams } from "../../lib/api/params";
import {
  normalizeUserTransactionsResponse,
  type UserActivityTransaction,
} from "./userActivityTransactionUtils";

export const USER_EXPORT_PAGE_LIMIT = 100;
export const MAX_USER_EXPORT_PAGES = 200;

export type UserTransactionsExportRange = {
  startDate: string;
  endDate: string;
};

export async function fetchUserTransactionsForExport(
  userId: string,
  range: UserTransactionsExportRange
): Promise<UserActivityTransaction[]> {
  const transactions: UserActivityTransaction[] = [];
  let totalPages = 1;

  for (let page = 1; page <= totalPages; page++) {
    if (page > MAX_USER_EXPORT_PAGES) {
      throw new Error(
        `Export is limited to ${MAX_USER_EXPORT_PAGES} pages (up to ${
          MAX_USER_EXPORT_PAGES * USER_EXPORT_PAGE_LIMIT
        } rows). Narrow the date range.`
      );
    }

    const { data } = await axiosInstance.get<{ data?: unknown }>(
      `api/admin/users/${userId}/transactions`,
      {
        params: compactParams({
          page,
          limit: USER_EXPORT_PAGE_LIMIT,
          startDate: range.startDate,
          endDate: range.endDate,
        }),
      }
    );

    const normalized = normalizeUserTransactionsResponse(data?.data);
    if (page === 1) {
      totalPages = Math.max(1, normalized.meta.totalPages ?? 1);
    }

    transactions.push(...normalized.transactions);
    if (normalized.transactions.length === 0) break;
  }

  return transactions;
}
